import { Extension } from "@tiptap/core";
import { Subscript as TiptapSubscript } from "@tiptap/extension-subscript";
import { Superscript as TiptapSuperscript } from "@tiptap/extension-superscript";
import { ActionButton } from "../../components";

export const SubAndSuperScript = Extension.create({
	name: "subAndSuperScript",

	addOptions() {
		return {
			...this.parent?.(),
			button: ({ editor, extension, t }) => {
				const subscript = extension.options.subscript;
				const superscript = extension.options.superscript;

				const subBtn = {
					component: ActionButton,
					componentProps: {
						action: () => editor.commands.toggleSubscript(),
						isActive: () => editor.isActive("subscript") || false,
						icon: "Subscript",
						tooltip: t("editor.subscript.tooltip")
					}
				};

				const superBtn = {
					component: ActionButton,
					componentProps: {
						action: () => editor.commands.toggleSuperscript(),
						isActive: () => editor.isActive("superscript") || false,
						icon: "Superscript",
						tooltip: t("editor.superscript.tooltip")
					}
				};

				const items = [];

				if (subscript !== false) {
					items.push(subBtn);
				}
				if (superscript !== false) {
					items.push(superBtn);
				}

				return items;
			}
		};
	},

	addExtensions() {
		const extensions = [];

		if (this.options.subscript !== false) {
			extensions.push(TiptapSubscript.configure(this.options.subscript));
		}

		if (this.options.superscript !== false) {
			extensions.push(TiptapSuperscript.configure(this.options.superscript));
		}

		return extensions;
	}
});
